import { DeliveryVoucher } from 'contracts/DeliveryVouchers';
import { create } from 'zustand';

type State = {
  deliveryVoucher?: DeliveryVoucher,
}

type Actions = {
  setDeliveryVoucher: (deliveryVoucher: DeliveryVoucher) => void,
  resetDeliveryVoucherStoreState: () => void,
}

const getInitialState = (): State => ({
  deliveryVoucher: undefined,
});

export const useDeliveryVoucherStore = create<State & Actions>(
  (set) => ({
    ...getInitialState(),
    setDeliveryVoucher: (deliveryVoucher) => set({ deliveryVoucher }),
    resetDeliveryVoucherStoreState: () => set(getInitialState()),
  }),
);